export default {

    LOAD_RECEIPTS(state, receipt) {
        state.items = receipt;
    }

}